import React from 'react';
import styles from './ModalTransportTenant.module.scss';
import { Empty, Icon, message, Modal, Spin } from 'antd';
import TransportCard from '../TransportCard/TransportCard';
import useTransports from '../../../../../queries/useTransports';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeTransportsModal,
  setVisibleTransportForm,
} from '../../../../../store/actions/housingStockActions';
import RoundedButton from '../../../../../../../components/RoundedButton/RoundedButton';
import { useQueryClient } from 'react-query';
import { getQueryKeys } from '../../../../../queries/queryKeys';

const Footer = ({ handleClose, data, onSuccess, houseId }) => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const handleOpenModal = () => {
    const flatsGrid =
      queryClient.getQueryData(getQueryKeys.flatsGrid(houseId)) || [];

    const flatFind = flatsGrid?.find(
      (item) => item.addressId === data.addressId
    );

    if (!flatFind || !flatFind?.allowTransportPermit) {
      message.info(
        'Добавить ТС на выбранный дом нельзя. Выберите другой дом!',
        3
      );
      return;
    }

    dispatch(
      setVisibleTransportForm({
        ...data,
        onSuccess,
      })
    );
  };

  return (
    <div className={styles.footer}>
      <RoundedButton
        text="Закрыть"
        onClick={handleClose}
        type="link"
        className={styles.closeBtn}
      />
      <RoundedButton
        text="Добавить ТС"
        onClick={handleOpenModal}
        iconRight={
          <Icon type="plus-square" style={{ color: 'white', fontSize: 16 }} />
        }
        type="primary"
        className={styles.addBtn}
      />
    </div>
  );
};

const ModalTransportTenant = () => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const { visible, tenant, houseId, addressId } =
    useSelector((state) => state.housingStockStore.visibleTransportTenant) ||
    {};

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const { data: transports = [], isFetching } = useTransports({
    clientId: tenant?.id,
    houseId,
  });

  const hasTransports = !!transports?.length;

  const keyTransports = getQueryKeys.transports({
    clientId: tenant?.id,
    houseId,
  });

  const handleClose = () => {
    dispatch(closeTransportsModal());
  };

  const onSuccessByActions = () => {
    queryClient.refetchQueries(keyTransports);
    queryClient.refetchQueries(getQueryKeys.flatsGrid(houseId));
  };

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      title={tenant?.fio || tenant?.name || ''}
      width={900}
      bodyStyle={{ backgroundColor: '#F7F9FD' }}
      footer={
        <Footer
          handleClose={handleClose}
          data={{ clientId: tenant?.id, addressId }}
          onSuccess={onSuccessByActions}
          houseId={houseId}
        />
      }
    >
      <Spin spinning={isFetching}>
        {hasTransports ? (
          <div className={styles.root}>
            <div className={styles.header}>Транспортные средства</div>
            <div className={styles.content}>
              {transports.map((item) => (
                <TransportCard
                  item={item}
                  key={item?.transport?.id}
                  tenant={tenant}
                  addressId={addressId}
                  companyId={currentCompany?.id}
                  onSuccess={onSuccessByActions}
                />
              ))}
            </div>
          </div>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Транспортные средства отсутствуют"
          />
        )}
      </Spin>
    </Modal>
  );
};

export default ModalTransportTenant;
